import styled from 'styled-components';

import { ModalBody, Input, Button } from 'reactstrap';
import { color } from '../../assets/styles/colors';

export const Title = styled.h5`
	background-color: ${color.modalGreen};
	font-size: 18px;
	font-weight: bold;
	padding: 11px 0 11px 4vw;
	overflow: auto;
	border-bottom: 1px solid black;
`;

export const Line = styled.div`
	margin: 10px 0px 0px 0px;
	border-bottom: 1px solid black;
	width: 100%;
`;

export const ModalBodyCss = styled(ModalBody)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 2vh 4vw 6vh 4vw;
`;



export const TextPrincipal = styled.p`
	padding: 10px 20px 10px 0px;

	@media (max-width: 768px) {
		padding: 5px;
	}
`;

export const ModalFooterCss = styled.div`
	background-color: ${color.modalGreen};
	display: flex;
	border-top: 1px solid black;
	text-align: right;
	width: 100%;

	@media (max-width: 768px) {
		text-align: center;
		flex-direction: column;
	}
`;

export const ButtonCss = styled(Button)`
	font-size: 14px;
	min-height: 32px;
	font-weight: bold;
	margin: 18px;
	background-color: ${color.yellow};
`;

export const ButtonFooterCss = styled(Button)`
	font-size: 14px;
	flex: 1;
	min-height: 32px;
	font-weight: bold;
	margin: 18px;
	background-color: ${color.yellow};
	transition: all ease 1s;
`;

export const InputCss = styled(Input)`
	min-height: 200px;
`;

export const TextError = styled.div`
	color: ${color.red};
`;
